import React, { Component } from 'react'
import { connect } from 'react-redux'

import { shareLogin } from '../redux/auth'
import ErrorMessage from '../components/ErrorMessage'
import LoadingSpinner from '../components/LoadingSpinner'

class Share extends Component {
  componentDidMount () {
    const { params, location, shareLogin } = this.props
    shareLogin(params.code, location.query.path)
  }
  render () {
    const { error } = this.props
    if (error) {
      return <ErrorMessage message='The code given is invalid or has expired.' />
    }
    return <LoadingSpinner />
  }
}

const mapStateToProps = ({ auth }) => ({
  error: auth.error
})

const mapDispatchToProps = {
  shareLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(Share)



// WEBPACK FOOTER //
// ./src/pages/Share.js